import dayjs from 'dayjs';

// TODO: Implement these within FS
export const DateHelper = {
  postDate: (d) => dayjs(d).format('YYYY-MM-DDT00:00:00'),
  postDateTime: (d) => dayjs(d).format('YYYY-MM-DDTHH:mm:ss'),
  getFSDate: (d) => dayjs(d).format('YYYYMMDD'),
  getDate: (d) => (dayjs(d).isValid() ? dayjs(d).format('YYYY-MM-DD') : ''),
  getDateTime: (d) => dayjs(d).format('YYYY-MM-DD HH:mm'),
  getTime: (d) => dayjs(d).format('HH:mm'),
  isValid: (d) => dayjs(d).isValid(),
};
